import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UserManagmentService } from '../../user-managment.service';
import { Router } from '@angular/router';
import { User } from '@root/components/user-managment/user-managment.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '@common/confirmation-dialog/confirmation-dialog.component';
import { BlockDialogComponent } from '@common/block-dialog/block-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { ResetPasswordComponent } from '../../reset-password/reset-password.component';
import { EncryptionProviderService } from '@shared/encryption.service';
import { ErrorHandler } from '@root/utils/error-handler.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  providers: [UserManagmentService],
})
export class UserListComponent implements OnInit {
  filterOptionList = [];

  filterOption: string;

  searchByName: string;

  activeUserId: number;

  panelMap: { [key: string]: boolean } = {};

  @Input() userList: User[] = [];

  @Output() editChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public userManagmentService: UserManagmentService,
    private router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    public encryptionProviderService: EncryptionProviderService,
    private errorHandler: ErrorHandler
  ) {}

  ngOnInit() {
  }

  public readUser() {
    const obj = {};
    this.userManagmentService.readUsers(obj).subscribe(
      (response) => {
        this.userList = response.data.list;
      },
      (error) => {}
    );
  }

  public resetPassword(user) {
    const resetPasswordDialog = this.dialog.open(ResetPasswordComponent, {
        height: '350px',
        width: '600px',
        data: { value : user}
    });
    resetPasswordDialog.afterClosed().subscribe((response) => {
      if (response) {
        const requestObj = {
          userId: response.data.value.userId,
          password: this.encryptionProviderService.encryptData(response.newPassword)
        };
        this.userManagmentService.resetPassword(requestObj).subscribe(
          (response) => {
            if (response.status === 0) {
              this.toastr.success(response.message);
            } else {
              this.errorHandler.handleError(response);
            }
          },
          (error) => {
            this.errorHandler.handleError(error);
          }
        );
      }
    });
  }

  public openDeleteDialog(userData) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '207px',
      width: '486px',
      data: { value: userData,mode:'DELETE' },
    });
    dialogRef.afterClosed().subscribe((respose) => {
      if (respose.status) {
        const requestObj = {
          userId: respose.data.id,
        };
        this.userManagmentService.deleteUsers(requestObj).subscribe(
          (response) => {
            if (response.status === 0) {
              this.toastr.success(response.message);
              this.readUser();
            } else {
              this.errorHandler.handleError(response);
            }
          },
          (error) => {
            this.errorHandler.handleError(error);
          }
        );
      }
    });
  }

  onEditUser(obj: any) {
    this.editChange.emit(obj);
    this.scrollTop();
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  public openBlockDialog(userData) {
    const isBlock  = userData.isBlocked;
    const dialogRef = this.dialog.open(BlockDialogComponent, {
      height: '207px',
      width: '486px',
      data: { value: userData, isBlock },
    });
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        const reqObj = {
          id: response.data.value.id,
          status: response.data.isBlock ? 1 : 0
        };
        this.userManagmentService.blockUsers(reqObj).subscribe(
          (respnose) => {
            if (respnose.status === 0) {
              this.toastr.success(respnose.message);
              this.readUser();
            } else {
              this.errorHandler.handleError(response);
            }
          },
          (error) => {
            this.errorHandler.handleError(error);
          }
        );
      }
    });
  }
}
